
// => Styling
import styles from './Indicator.module.css';

// => Icons
import { IoWarning } from "react-icons/io5";

// => React hooks
import { cloneElement } from 'react';


// ============
// Component
// ============
const Indicator = ({
    value = 1,
    icon = <IoWarning />,
    size = "36px",
}) => {

    const enabled = () => {
        return value !== null && value > 0
    }


    // RENDER
    // ---------
    return(
        <div className={styles.container} style={{
            width: size,
            height: size,
        }}>
            {enabled() && cloneElement(icon, { className: [styles.icon, icon?.props.className].join(" "),
                                    style: {} })}
        </div>
    )
}


export default Indicator